export default "__VITE_ASSET__BdADHdKj__"